import React from 'react'
import styled from 'styled-components'
import {Check} from 'lucide-react'

interface CustomCheckboxProps {
  checked: boolean
  onChange: (checked: boolean) => void
  label?: string
  disabled?: boolean
  className?: string
}

const CheckboxContainer = styled.label<{$disabled: boolean}>`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.$disabled ? 0.5 : 1)};
  user-select: none;
`

const CheckboxInput = styled.input`
  display: none;
`

const CheckboxBox = styled.div<{$checked: boolean; $disabled: boolean}>`
  width: 16px;
  height: 16px;
  border: 2px solid ${(props) => (props.$checked ? '#03a9fc' : '#d1d5db')};
  border-radius: 4px;
  background: ${(props) => (props.$checked ? '#03a9fc' : '#ffffff')};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${(props) => (props.$disabled ? '#d1d5db' : '#03a9fc')};
  }
`

const CheckIcon = styled(Check)<{$checked: boolean}>`
  width: 12px;
  height: 12px;
  color: white;
  opacity: ${(props) => (props.$checked ? 1 : 0)};
  transition: opacity 0.2s ease;
`

const CheckboxLabel = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: #374151;
`

export const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
  checked,
  onChange,
  label,
  disabled = false,
  className,
}) => {
  const handleChange = () => {
    if (!disabled) {
      onChange(!checked)
    }
  }

  return (
    <CheckboxContainer $disabled={disabled} className={className} onClick={handleChange}>
      <CheckboxInput
        type="checkbox"
        checked={checked}
        onChange={() => {}} // Handled by container click
        disabled={disabled}
      />
      <CheckboxBox $checked={checked} $disabled={disabled}>
        <CheckIcon $checked={checked} />
      </CheckboxBox>
      {label && <CheckboxLabel>{label}</CheckboxLabel>}
    </CheckboxContainer>
  )
}

export default CustomCheckbox
